module.exports = __webpack_public_path__ + "static/plastique-beaute-couverture-89c6471ab181178b3e4b14e6a02723d1.jpg";